/* eslint-disable max-len */
import React, { useEffect, useMemo } from 'react';
import {
  Grid, Card, FormControlLabel, Radio, RadioGroup, FormControl,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Controller } from 'react-hook-form';
import { useLocation, useParams } from 'react-router-dom';
import CustomCheckbox from '../../../../../Common/ComponentCustomCheckBox';
import ComponentSelectInput from '../../../../../Common/ComponentSelectInput';
import ComponentTextInput from '../../../../../Common/ComponentTextinput/ComponentTextInput';
import RequiredFiled from '../../../../../Common/RequiredField';
import { UnitInfoFormNames } from '../../utils/constants';
import { RootState } from '../../../../../redux/rootState';
import { UnitFormComponentProps } from '../../utils/type';
import { pctRegex } from '../../../../../utils/regex';
import { getSerialNoStart, setIsUserInteracting } from '../../redux/unitInfoSlice';

export default function UnitFormComponent({
  control, handleChange, watch, setValue,
}: UnitFormComponentProps) {
  const { isNewJob } = useParams();
  const {
    unitMaster, machineType, SerialNo, selectedUnit,
  } = useSelector((state:RootState) => state.unitInfoReducer);

  useEffect(() => {
    if (selectedUnit?.UnitInfo) {
      setValue('isSmallTube', selectedUnit.UnitInfo.IsSmallTube);
    }
  }, [selectedUnit]);

  const testType = watch(UnitInfoFormNames.testType);
  const spotTest = useSelector((state: RootState) => state.unitInfoReducer.unitInfo.spotTest);
  const dispatch = useDispatch();
  const NewSerialNo = SerialNo?.split('=')[1]?.trim();
  const { pathname } = useLocation();

  const handlePCTChange = (val:boolean) => {
    handleChange();
    if (!val) {
      setValue(UnitInfoFormNames.pct, '');
    }
    dispatch(setIsUserInteracting(true));
  };

  useEffect(() => {
    if (pathname.includes('add-unit')) {
      dispatch(getSerialNoStart());
    }
  }, [pathname]);

  useEffect(() => {
    setValue(UnitInfoFormNames.serialNumber, NewSerialNo);
  }, [NewSerialNo]);

  const isJobCompleted = useMemo(() => (selectedUnit?.IsCompleted || selectedUnit?.IsSynced), [selectedUnit]);

  return (
    <>
      <Grid item md={12} sm={12} xs={12}>
        <Card>
          <div className="customerInfo_container">
            <div className="customerInfo">
              Type of Test
              <RequiredFiled />
            </div>
            <div className="double_checkbox">
              <CustomCheckbox
                control={control}
                name={UnitInfoFormNames.safetyEqRequired}
                handleChange={handleChange}
                label="Safety Equipment Required"
                isDisable={isJobCompleted}
              />
              <CustomCheckbox
                control={control}
                name={UnitInfoFormNames.safetyCharges}
                label="Safety Charges"
                handleChange={() => {
                  handleChange();
                  dispatch(setIsUserInteracting(true));
                }}
                defaultValue={false}
              />
              {
                (isNewJob === 'new' && testType === UnitInfoFormNames.absTest) && (
                <CustomCheckbox
                  control={control}
                  name="isSmallTube"
                  label="Is Small Tube?"
                  handleChange={() => {
                    handleChange();
                    dispatch(setIsUserInteracting(true));
                  }}
                  isDisable={isJobCompleted}
                />
                )
              }
            </div>
          </div>
          <div className="customerInfo_main_container">
            <Grid container spacing={2}>
              <Grid item md={9} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">&nbsp;</label>
                  <Controller
                    name={UnitInfoFormNames.testType}
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange } }) => (
                      <FormControl>
                        <RadioGroup
                          row
                          value={testType}
                          key={testType}
                          defaultValue={UnitInfoFormNames.eddyCurrentTest}
                          onChange={(event) => {
                            onChange(event);
                            handleChange();
                            dispatch(setIsUserInteracting(true));
                          }}
                        >
                          <div className="type_of_test">
                            <FormControlLabel
                              labelPlacement="start"
                              value={UnitInfoFormNames.eddyCurrentTest}
                              control={<Radio color="success" />}
                              label={<span className="radio_button_style">Eddy Current Test</span>}
                              disabled={isJobCompleted}
                            />
                          </div>
                          <div className="type_of_test">
                            <FormControlLabel
                              labelPlacement="start"
                              value={UnitInfoFormNames.fluxLeakagetest}
                              control={<Radio color="success" />}
                              label={<span className="radio_button_style">Flux Leakage Test</span>}
                              disabled={isJobCompleted}
                            />
                          </div>
                          <div className="type_of_test">
                            <FormControlLabel
                              labelPlacement="start"
                              value={UnitInfoFormNames.absTest}
                              control={<Radio color="success" />}
                              label={<span className="radio_button_style">Abs / Diff Test</span>}
                              disabled={isJobCompleted}
                            />
                          </div>
                        </RadioGroup>
                      </FormControl>
                    )}
                  />
                </div>
              </Grid>
              {
                testType === UnitInfoFormNames.fluxLeakagetest ? (
                  <Grid item md={3} sm={6} xs={12}>
                    <div className="div_label_text">
                      <label className="label_Style_job">
                        OD of Tubes
                        {' '}
                        <RequiredFiled />
                        {' '}
                      </label>
                      <ComponentTextInput
                        control={control}
                        required
                        type="number"
                        name={UnitInfoFormNames.odTubes}
                        // regEx={RegexTwoWith2D}
                        // regEx={/^\d+(\.\d{0,3})?$/}
                        regEx={/^(?:\d+|\d*\.\d{1,4})$/}
                        id={UnitInfoFormNames.odTubes}
                        size="small"
                        handleChange={() => {
                          handleChange();
                          dispatch(setIsUserInteracting(true));
                        }}
                        isDisable={isJobCompleted}
                      />
                    </div>
                  </Grid>
                ) : ''
              }
            </Grid>
          </div>
        </Card>
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <Card>
          <div className="customerInfo_container">
            <div className="customerInfo">
              Unit Details
            </div>
          </div>
          <div className="customerInfo_main_container">
            <Grid container spacing={2}>
              <Grid item md={6} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Machine Type
                    {' '}
                    <RequiredFiled />
                    {' '}
                  </label>
                  <ComponentSelectInput
                    control={control}
                    defaultValue=""
                    name={UnitInfoFormNames.machineType}
                    required
                    size="small"
                    handleChange={() => {
                      handleChange();
                      dispatch(setIsUserInteracting(true));
                    }}
                    entries={machineType}
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Location (Building)
                  </label>
                  <ComponentTextInput
                    control={control}
                    name={UnitInfoFormNames.location}
                    id={UnitInfoFormNames.location}
                    handleChange={handleChange}
                    inputProps={{ maxLength: 35 }}
                    className="nonCapitalizeField"
                    // regEx={/^[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?~\\-\\/ ]{1,35}$/}
                    size="small"
                    isDisable={isJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Manufacturer
                    {' '}
                    <RequiredFiled />
                    {' '}
                  </label>
                  <ComponentSelectInput
                    control={control}
                    name={UnitInfoFormNames.manufacturer}
                    defaultValue=""
                    required
                    size="small"
                    handleChange={handleChange}
                    entries={unitMaster?.Manufacture || []}
                    disabled={isJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Model
                    {' '}
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={UnitInfoFormNames.model}
                    inputProps={{ maxLength: 25 }}
                    handleChange={handleChange}
                    // regEx={/^[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?~\\-\\/ ]{1,10}$/}
                    id={UnitInfoFormNames.model}
                    size="small"
                    isDisable={isJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">Type</label>
                  <ComponentSelectInput
                    control={control}
                    name={UnitInfoFormNames.type}
                    handleChange={handleChange}
                    defaultValue=""
                    size="small"
                    entries={unitMaster?.Type || []}
                    disabled={isJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">Style</label>
                  <ComponentSelectInput
                    control={control}
                    name={UnitInfoFormNames.style}
                    defaultValue=""
                    size="small"
                    handleChange={handleChange}
                    entries={unitMaster?.Style || []}
                    disabled={isJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Serial #
                    {' '}
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    name={UnitInfoFormNames.serialNumber}
                    id={UnitInfoFormNames.serialNumber}
                    defaultValue={NewSerialNo}
                    className="nonCapitalizeField"
                    inputProps={{ maxLength: 25 }}
                    handleChange={handleChange}
                    size="small"
                    isDisable={isJobCompleted}
                  />
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">PO #</label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={UnitInfoFormNames.PONumber}
                    defaultValue=""
                    inputProps={{ maxLength: 25 }}
                    // regEx={/^[a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?~\\-\\/ ]{1,10}$/}
                    id={UnitInfoFormNames.PONumber}
                    handleChange={handleChange}
                    size="small"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <Card>
          <div className="double_checkbox_container">
            <CustomCheckbox isDisable={isJobCompleted} handleChange={handleChange} name={UnitInfoFormNames.leak} label="Leak" control={control} />
            <CustomCheckbox isDisable={isJobCompleted} handleChange={handleChange} name={UnitInfoFormNames.outside} label="Outside" control={control} />
          </div>
          <div className="customerInfo_main_container">
            <Grid container spacing={2}>
              <Grid item md={6} sm={6} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">Job Time </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={UnitInfoFormNames.jobTime}
                    defaultValue=""
                    id={UnitInfoFormNames.jobTime}
                    handleChange={handleChange}
                    // regEx={/^[A-Za-z ]{1,10}$/}
                    size="small"
                    isDisable={isJobCompleted}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <Card>
          <div className="customerInfo_container">
            <div className="customerInfo">
              Spot Test
            </div>
          </div>
          <div className="customerInfo_main_container">
            <Grid container spacing={2}>
              <Grid item md={12} sm={12} xs={12}>
                <div className="unit_test_style">
                  <div>
                    <label>&nbsp;</label>
                    <CustomCheckbox
                      defaultValue={false}
                      name={UnitInfoFormNames.spotTest}
                      handleChange={handlePCTChange}
                      label="Spot Test"
                      control={control}
                      isDisable={isJobCompleted}
                    />
                  </div>
                  <div className="div_label_text">
                    <label className="label_Style_job">
                      Pct.
                      {spotTest && <RequiredFiled />}
                    </label>
                    <ComponentTextInput
                      control={control}
                      required={spotTest}
                      name={UnitInfoFormNames.pct}
                      defaultValue=""
                      type="number"
                      id={UnitInfoFormNames.pct}
                      onKeyDown={(e: { key: string; preventDefault: () => void; }) => {
                        if (['e', 'E', '-', '+'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      regEx={pctRegex}
                      isDisable={!spotTest || isJobCompleted}
                      handleChange={() => {
                        handleChange();
                        dispatch(setIsUserInteracting(true));
                      }}
                      size="small"
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Grid>
    </>
  );
}
